import React from "react";
import { Box } from "@mui/material";

export default function QuestionCodeWindow(props) {
  const { html } = props;
  const { name } = props;
  const { sx } = props;

  return (
    <Box sx={sx}>
      Preview
      <iframe
        style={{
          boxSizing: "border-box",
          height: "360px",
          width: "90%",
          border: "1px solid black",
          borderRadius: "5px",
          paddingLeft: "10px",
          backgroundColor: "white",
        }}
        srcDoc={html}
        id={name+"target"}
      />
    </Box>
  );
}
